import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import * as React from 'react';
import { MdFormatListNumbered } from 'react-icons/md';
import { BadgeList } from 'ui/badge-list';
import { ComponentProps } from 'ui';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { columnName, tableName } from 'app/area/case/case-data-model';
import styles from 'app/area/case/components/fact-box/fact-box.scss';

interface ConnectedCasesActionFactItemProps extends ComponentProps, FactItemProps {
  actionCount: number;
  closedActionCount: number;
  tooltipClosedActions: string;
  classNames?: string;
}

export const ConnectedCasesActionFactItem = (props: ConnectedCasesActionFactItemProps) => {
  const { actionCount, closedActionCount, tooltipClosedActions, tooltip, title, linkDomain, url, urlOpenNew } = props;
  const icon = <MdFormatListNumbered />;
  const items = [{ key: 1, value: actionCount, tooltip },
  {
    key: 2, value: closedActionCount, tooltip: tooltipClosedActions,
    classNames: (columnName[tableName.action] as any).numberOfClosedActions
  }];
  if (!actionCount) {
    return null;
  }
  return <li className={`${styles.factLink} fact-item actions-badge`}>
    <FactLink id={props.componentId} classNames={styles.factLink} section={linkDomain} url={url} urlOpenNew={urlOpenNew}>
      <BadgeList
        icon={icon}
        title={title}
        valueItems={items}
      />
    </FactLink>
  </li>;
};
